import React, { useState, useEffect } from 'react'
import TravelAdd from '../TravelAdd/TravelAdd'
import './TravelsPlanned.min.css'
import { Travel } from './model'
import { ipAddress } from '../../ipAddress'
import AllTravels from '../AllTravels/AllTravels'
import axios from "axios";




const TravelsPlanned = () => {

  const [addTravel, setAddTravel] = useState<boolean>(false);
  const [city, setCity] = useState<string>('');
  const [date, setDate] = useState<string>('');
  const [dateEnd, setDateEnd] = useState<string>('');
  const [travels, setTravels] = useState<Travel[]>([]);
  const [updateCity, setUpdateCity] = useState(false)

  async function getCities() {

  
    await axios.get(ipAddress + '/getcities')
      .then((response) => {
        setTravels(response.data)
        
      }
      )

      .catch(function (error) {
        console.log("error!")

      })
    setUpdateCity(false)

  }

  useEffect(() => {
    getCities();
  }, [updateCity])

  console.log(ipAddress)


  const finishTravel = () => {

    for (let i = 0; i < travels.length; i++) {
      let date2 = new Date();
      let dateStart = new Date(travels[i].date);
      let dateEnd = new Date(travels[i].dateEnd);
      let id = travels[i].id;
      //let dateFormart = new Date(`"${month}/${day}/${year}"`);
      let timeDiff: number;
      let diffDays: number;
      if (travels[i].dateEnd !== '') {
        timeDiff = date2.getTime() - dateEnd.getTime();
        diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

      } else {
        if (travels[i].date !== '') {
          timeDiff = date2.getTime() - dateStart.getTime();
          diffDays = Math.floor(timeDiff / (1000 * 3600 * 24));

        }
      }

      if (diffDays > 0) {
        axios.post(ipAddress + "/donecity", {
          id: id,
          isDone: 1,

        })
        console.log('update')
        setUpdateCity(true)

      }

    }

  }

  useEffect(() => {
    if (travels.length > 0) {
      finishTravel()
    }
  }, [travels])



  async function handleAdd(e: React.FormEvent) {
    e.preventDefault();

    if (city) {

      await axios.post( ipAddress + "/addcity", {
        id: Math.random(),
        city: city,
        date: date,
        dateEnd: dateEnd,
        isDone: 0,
      })
        .then((response) => {
          /*  setTravels( [ ...travels, {id:Math.random(), city, date, isDone:false }] ) */
        })
        .catch(function (error) {
          console.log("error!")

        })
    }




    setCity('');
    setDate('');
    setDateEnd('');
    setAddTravel(false)
    setUpdateCity(true)

  }
  return (

    <div className='travels'>

      <footer>
        <button type='button' onClick={() => setAddTravel(true)} id='circle'><p>+</p></button>
      </footer>
      <TravelAdd addTravel={addTravel} setAddTravel={setAddTravel}
        city={city} setCity={setCity} date={date} setDate={setDate} dateEnd={dateEnd} setDateEnd={setDateEnd}
        handleAdd={handleAdd} />
      <AllTravels travels={travels} setTravels={setTravels} />
    </div>
  )
}

export default TravelsPlanned